export default __webpack_public_path__ + "static/media/sgd-5.3d39207e.png";